
module.factory('QueryStringFilter', function($location) {

    function QueryStringFilter(defaults) {

        this.initToDefaults = function() {
            for(var name in defaults) {
                this[name] = defaults[name];
            }
        };


        this.toQueryString = function() {
            for (var name in defaults) {
                if (this[name] == defaults[name]) {
                    $location.search(name, null);
                }
                else {
                    $location.search(name, this[name]);
                }
            }
            $location.replace();
        };


        this.fromQueryString = function() {
            for(var name in defaults) {
                this[name] = $location.search()[name];
                if (!this[name]) {
                    this[name] = defaults[name];
                }
            }
        };

        this.params = function(defaultParams) {
            var params = defaultParams || {};
            for (var name in defaults) {
                params[name] = this[name];
            }
            return params;
        };

        this.fromQueryString();
    }

    return function(defaults) {
        return new QueryStringFilter(defaults);
    };
});
